<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" slot="detail">
        <a-row :disabled="formDisabled">
          <a-col :span="12">
            <a-form-model-item :label="language['eletronicSigned.processNo']"  :labelCol="labelCol" :wrapperCol="wrapperCol"><!-- prop="applicationCode"-->
              <a-input v-model="model.processNo" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['eletronicSigned.startTime']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                style="width: 100%"
                :disabled="true"
                v-model="model.startTime"
                format="YYYY-MM-DD HH:mm:ss"
                :getCalendarContainer="node => node.parentNode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-tabs @change="changeTabs" default-active-key="1" size="large" :tab-bar-style="{marginBottom: '12px', paddingLeft: '16px'}" >
          <a-tab-pane loading="true" :tab="model.processName" key="1"
                      :style="innerFullscreen===false?(setEdit===true?`max-height: 32vh;overflow:scroll;`:`max-height: 45vh;overflow:scroll;`):(setEdit===true?`max-height: 54vh;overflow:scroll;`:`max-height: 65vh;overflow:scroll;`)">
            <details-modal  :form-id="model.formId" :form-no="model.businessFormNo"/>
          </a-tab-pane>
          <a-tab-pane :tab="language['eletronicSigned.signList']" key="3"
                      :style="innerFullscreen===false?(setEdit===true?`max-height: 32vh;overflow:scroll`:`max-height: 45vh;overflow:scroll`):(setEdit===true?`max-height: 45vh;overflow:scroll`:`max-height: 65vh;overflow:scroll`)">
            <a-card  :loading="loading" :bordered="false" :title="language['eletronicSigned.signList']">
              <a-table
                size="middle"
                rowKey="id"
                :columns="columns"
                :pagination="false"
                :dataSource="dataSource"
                :loading="loading">
              </a-table>
            </a-card>
            <a-card  :loading="loading" :bordered="false" :title="language['eletronicSigned.signPerson']">
              <a-table :columns="approverColumns" size="middle"
                       :data-source="approverData" :pagination="false" :loading="loading" ></a-table>
            </a-card>
          </a-tab-pane>
          <a-tab-pane :tab="language['eletronicSigned.processChart']" key="4" :style="innerFullscreen===false?(setEdit===true?`max-height: 32vh;overflow:scroll`:`max-height: 45vh;overflow:scroll`):(setEdit===true?`max-height: 45vh;overflow:scroll`:`max-height: 65vh;overflow:scroll`)">
            <div style="padding: 10px;overflow-x: scroll;">
              <a-steps  size="small">
                <a-step :title="language['bpm.sign.startTaskName']"  status="finish">
                  <template slot="description">
                    <p style="color:green" slot="title">{{model.createUserRealname}}</p>
                  </template>
                </a-step>
                <a-step  :title="item.taskName" v-for="(item,index) in chartList" :key="index"
                         :status="item.taskStatus=='Ready'?'process':(item.taskStatus=='Rejected'?'error':(item.taskStatus=='Completed'?'finish':'wait'))" >
                  <template slot="description">
                    <p slot="title" v-for="(signUser,i) in item.signUsers" :key="i"
                       :style="(model.processStatus=='Cancelled')?(signUser.isSign==1?'color:green':''):(signUser.isSign==1?'color:green':(signUser.ready?'color:red':''))" >
                      {{signUser.userCodeName}}
                    </p>
                  </template>
                </a-step>
                <a-step :title="language['bpm.sign.endTaskName']" description="" :status="model.processStatus == 'Completed'?'finish':'wait'"/>
              </a-steps>
            </div>
          </a-tab-pane>
        </a-tabs>
        <a-card :bordered="false" :title="language['eletronicSigned.signOpinion']" v-if="setEdit">
          <div>
            <a-row>
              <a-textarea v-model="model.comments" maxlength="1000"></a-textarea>
            </a-row>
            <div style="text-align: center;">
              <a-button style="color: blue;right: 20px;padding-left: 30px;padding-right: 30px;" @click="agree" >{{language['eletronicSigned.agree']}}</a-button>
              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>
            </div>
          </div>
        </a-card>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"
  import {httpAction, getAction, postAction} from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'
  import ATextarea from "ant-design-vue/es/input/TextArea";
  // import {epm_agree} from '../auditJS/agree'
  import {agree} from '../auditJS/agree'
  import {reject} from '../auditJS/reject'
  import JFilePop from '@/components/jeecg/minipop/JFilePop'
  import DetailsModal from './DetailsModal'



  export default {
    name: 'MyToForm',
    components: {
      ATextarea,
      JInput,
      JFilePop,
      DetailsModal,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      innerFullscreen: {
        type: Boolean,
      },
      setEdit: {
        type: Boolean,
      }
    },
    data() {
      return {
        loading:true,
        model: {},
        chartList:[],
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        approverData:[],
        dataSource:[],
        url: {
          loadApproveResult: "/sys/wfapi/loadApproveResultGet",//获取签核记录
          getAllTaskApproversInfo: "/sys/wfapi/getAllTaskApproversInfo",//获取所有签核人
        },
        processModel:{},
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              dataIndex: 'taskName',
              width: 120,
            },
            {
              title: this.language['eletronicSigned.signPerson'],
              align: "center",
              width: 100,
              dataIndex: 'signUserName',
            },
            {
              title: this.language['eletronicSigned.signResult'],
              align: "center",
              width: 80,
              dataIndex: 'signResult_dictText',
              // scopedSlots: {customRender: 'approveResult'},
              /*customRender: function (text, r, index) {
                if (text === 'Cancel') {
                  // return this.language['eletronicSigned.termination']
                  return this.getLanguage('eletronicSigned.termination')
                } else {
                  return r.actionTextLocalLang;
                }
              }*/
            },
            {
              title: this.language['eletronicSigned.signOpinion'],
              align: "center",
              width: 80,
              dataIndex: 'signComments',
            },
            {
              title: this.language['eletronicSigned.signDate'],
              align: "center",
              width: 100,
              dataIndex: 'createTime'
            },
          ]
        }
      },
      approverColumns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              dataIndex: 'taskName'
            },
            {
              title: this.language['eletronicSigned.signPersonWorkNo'],
              align: "center",
              dataIndex: 'userCode'
            },
            {
              title: this.language['eletronicSigned.signPerson'],
              align: "center",
              dataIndex: 'userCodeName'
            },
            {
              title: this.language['eletronicSigned.signPersonMail'],
              align: "center",
              dataIndex: 'userEmail'
            },
          ]
        }
      },
      formDisabled() {
        return this.disabled
      },
    },

    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },

    methods: {
      changeTabs(activeKey){
      },
      initChartList(processId){
        getAction("/sys/bpm/processTask/getVOlistByProcessId",{processId:processId}).then(res=>{
          if(res.success){
            this.chartList = res.result;
          }
        })
      },
      getAllTaskApproversInfo(processNo){
        this.loading = true;
        getAction("/sys/bpm/processTaskUser/getVOListByProcessNo",{processNo:processNo}).then(res=>{
          if (res.success) {
            this.approverData = res.result;
          }
        }).finally(()=>{
          this.loading = false;
        });
      },

      loadApproveResult(processNo){
        this.loading = true;
        getAction("/sys/bpm/processTaskUserResult/getlistByProcessNo",{processNo:processNo}).then(res=>{
          if (res.success) {
            this.dataSource = res.result;
          }
        }).finally(()=>{
          this.loading = false;
        });
      },

      //同意
      agree(){
        agree(this);
      },
      //驳回
      reject(){
        reject(this);
      },
      add() {
        this.edit(this.modelDefault);
      },

      edit(record) {
        // this.setEdit = record.setEdit!==null&&record.setEdit!==''&&record.setEdit!==undefined?record.setEdit:false;
        this.model = Object.assign({}, record);
        this.visible = true;

        this.loadApproveResult(this.model.processNo);
        this.getAllTaskApproversInfo(this.model.processNo);
        this.initChartList(this.model.id)
      },

      beforeUpload: function (file) {
        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning(this.language['warning.pleaseUploadImage']);
          return false;
        }
        //TODO 验证文件大小
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ant-card-body {
    padding: 5px;
    zoom: 1;
  }

</style>